<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <block-cntr :btitle="'IGMP Snooping Router Table'" style="height: 410px">
        <div class="form-inline">
          <span style="float: left">
            <div class="btn-group open">
              <div
                @click="loadIgmpRouterInfo()"
                class="btn"
                :class="{ disabled: false }"
                style="padding: 0px"
              >
                <i class="fa fa-refresh page-tableaction"></i>
              </div>
            </div>
          </span>
        </div>

        <table class="table table-hover table-noneborder-top">
          <thead>
            <tr>
              <th
                v-for="(value, key) in title"
                :key="key"
                :title="value"
              >
                {{ value }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(row, index) in igmpTable"
              :key="index"
              :class="{ 'true:': true }"
            >
             <td v-for="(value, key) in row" :key="key" :title="value"   
                 :style="{
                    width:
                      key === 'mac' || key === 'group' ? '120px' : 'auto',
                  }">
                <div>{{ value }}</div>
            </td>
            </tr>
          </tbody>
        </table>
      </block-cntr>
      </div>
    </div>

    <info-box :ibox="iBox"></info-box>
  </div>
</template>

<script>
import en from "../lang/en-US.js"
import BlockCntr from "../components/BlockCntr.vue"
import DialogBox from "@/components/DialogBox"
import { get, post } from "@/utils/http.js"
import InfoBox from "../components/InfoBox.vue"

export default {
  name: "igmpsnooprouter",
  components: {
    BlockCntr,
    InfoBox,
    DialogBox,
  },

  data() {
    return {
      title: {},
      isShowAddTable: false,
      isEditClik: false,
      isSelectAll: false,
      iBox: {},
      select: [],
      igmpTable: [],
    }
  },

  created() {
    this.loadIgmpRouterInfo()
  },

  methods: {
    loadIgmpRouterInfo() {
      get("igmpSnoopRouter")
        .then((res) => {
          this.igmpTable = res.data.data
          this.title    = res.data.title
          console.log(res.data)
        })
        .catch((err) => {
          console.log(err)
        })
    },

    clkCancel() {
      this.resetField()
      this.isShowAddTable = false
      this.isEditClik = false
    },

    showAlertBox(type, title, txt) {
      this.iBox = {
        visible: true,
        type: type, // info warn critical
        title: title,
        txt: txt,
        btxt: "Close",
      }
    },
  },
}
</script>
